import { useRef } from 'react';

// Use this hook if you need a uniques id that is persistent between re-renders
export function useUniqueId() {
    const idRef = useRef(null);
    if (!idRef.current) {
        idRef.current = `id-${Math.random().toString(36).substring(2, 9)}`;
    }
    return idRef.current;
}
